import { useEffect, useState } from "react";
import { getSrcOfIframe } from "../embedUtilities";

const UseGoogleMapsPreview =  (url:string, isLoading: boolean, setIsLoading: any, setDisableUpload: any) => {
    const [id, setId] = useState<string>('');
    const [errorString, setErrorString]=useState<string|null>(null);

    useEffect(() => {
        if (url) {
          setIsLoading(true)
          setId('');
          getMapsUrl(url)
        }
    },[])
  
    useEffect(()=> {
        if (id) {
          setDisableUpload(false);
        } else {
          setDisableUpload(true);
        }
        setIsLoading(false);
    }, [id, isLoading])
  
    async function getMapsUrl(googleMapsUrl: string){
        if(googleMapsUrl.includes('maps.app.goo.gl')) {
            setErrorString("You have entered a Google Maps share link. Please try again with a valid HTML embed code.");
            setId('');
            
        } else if(!googleMapsUrl.includes('embed?') && ((googleMapsUrl.startsWith('https://www.google.com/maps')) || (googleMapsUrl.startsWith('https://www.google.co.uk/maps')))) {
            setErrorString("You have entered a Google Maps URL. Please try again with a valid HTML embed code.");
            setId('');
                
        } else if(googleMapsUrl.includes("google")){
            setErrorString(null);

            if(googleMapsUrl.includes('<iframe')) {
                setId(getSrcOfIframe(googleMapsUrl));

            } else if(googleMapsUrl.startsWith('http') && googleMapsUrl.includes('embed?')) {
                setId(googleMapsUrl);

            } else {
                setId('');
            }

        } else {
            setId('');
            setErrorString(null);
        }
        setIsLoading(false);
    }
    return {errorString, id}
}

export default UseGoogleMapsPreview;
